import React, { Component } from 'react';
import SwalServices from '../../services/swalServices/SwalServices';
import ValidationText from '../../utils/validation/ValidationText';
import ImageCropperWithUpload from '../../components/ImageUpload/UploadImage';
import CommonServices from '../../services/axiosServices/apiServices/CommonServices';
import CKClassicEditor from '../../components/ckEditor/CKClassicEditor';
import InputText from '../../components/inputs/InputText';
import eVotingServices from '../../services/axiosServices/apiServices/eVotingServices';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import { CommonSuccessMessages } from '../../utils/Messages';

export default class Candidates extends Component {
  constructor(props) {
    super(props);
    this.swalServices = new SwalServices();
    this.commonServices = new CommonServices();
    this.eVotingServices = new eVotingServices();

    this.state = {
      adminUserId: 0,
      candidates: [
        {
          id: Date.now(),
          name: "",
          designation: "",
          companyName: "",
          videoUrl: "",
          description: "",
          imageUrl: "",
          errors: {
            name: "",
            designation: "",
            companyName: "",
           // description: ""
          }
        }
      ]
    };
  }

  componentDidMount() {
    let cookie = getAuthProps();
    const adminUserId = cookie?.adminUserId ? Number(cookie.adminUserId) : 0;

    this.setState({ adminUserId: adminUserId }, () => {
      this.getAllCandidateList();
    });

  }

  getAllCandidateList = () => {
    this.eVotingServices.getAllCandidateList().then((response) => {
      if (response && response.statusCode === 200 && response.responseItem != null) {
        const list = response.responseItem.responseContent || response.responseItem || response;
        // response.responseItem.responseContent may be itemList or direct list depending on API wrapper
        const items = Array.isArray(list) ? list : (Array.isArray(list.responseContent) ? list.responseContent : []);
        if (items && items.length) {
          const mapped = items.map((x) => ({
            id: x.candidateId ?? Date.now() + Math.random(),
            candidateId: x.candidateId ?? null,
            name: x.candidateName ?? "",
            designation: x.designation ?? "",
            companyName: x.company ?? "",
            videoUrl: x.videoUrlPath ?? "",
            description: x.description ?? "",
            imageUrl: x.candidateImage ?? "",
            errors: { name: "", designation: "", companyName: "", description: "" }
          }));
          this.setState({ candidates: mapped });
        }
      } else {
        if (response && response.message) this.swalServices.Error(response.message);
      }
    })
      .catch((err) => {
        console.error('Load candidates error', err);
        this.swalServices.Error('Failed to load candidates.');
      });
  }


  // Add a new empty candidate form card
  handleAddCandidate = () => {
    const newCandidate = {
      id: Date.now(),
      name: "",
      designation: "",
      companyName: "",
      videoUrl: "",
      description: "",
      imageUrl: "",
      errors: {
        name: "",
        designation: "",
        companyName: "",
        description: ""
      }
    };
    this.setState(prevState => ({
      candidates: [...prevState.candidates, newCandidate]
    }));
  };

  // Remove a candidate form card by ID
  handleRemoveCandidate = (id) => {
    if (this.state.candidates.length === 1) {
      this.swalServices.Error("At least one candidate is required.");
      return;
    }

    const candidate = this.state.candidates.find(c => c.id === id);

    // Not yet saved to DB — just remove locally
    if (!candidate || !candidate.candidateId) {
      this.setState(prevState => ({
        candidates: prevState.candidates.filter(c => c.id !== id)
      }));
      return;
    }

    // Existing candidate — soft delete on the server first
    this.swalServices.Confirm("", "Are you sure you want to remove this candidate?",CommonSuccessMessages.Yes_Text, CommonSuccessMessages.No_Text).then((confirmed) => {
      if (!confirmed) return;
      this.eVotingServices.deleteCandidate({ CandidateId: candidate.candidateId, DeletedBy: this.state.adminUserId })
        .then((response) => {
          if (response && response.statusCode === 200 && response.responseItem?.responseContent === "true") {
            this.setState(prevState => ({
              candidates: prevState.candidates.filter(c => c.id !== id)
            }));
            this.swalServices.Success("Candidate removed.");
          } else {
            this.swalServices.Error("Failed to remove candidate.");
          }
        })
    });
  };

  // Handle changes for text fields
  handleFieldChange = (e, id) => {
    const { name, value } = e.target;
    this.setState(prevState => {
      const updated = prevState.candidates.map(c => {
        if (c.id === id) {
          const newErrors = { ...c.errors };
          if (name === "name" || name === "designation" || name === "companyName") {
            newErrors[name] = value.trim() === "" ? `Candidate ${name} is required.` : "";
          }
          return { ...c, [name]: value, errors: newErrors };
        }
        return c;
      });
      return { candidates: updated };
    });
  };

  // Handle rich text editor changes
  handleEditorChange = (data, id) => {
    this.setState(prevState => {
      const updated = prevState.candidates.map(c => {
        if (c.id === id) {
          const newErrors = { ...c.errors };
          newErrors.description = data.trim() === "" ? "Description is required." : "";
          return { ...c, description: data, errors: newErrors };
        }
        return c;
      });
      return { candidates: updated };
    });
  };

  // Handle cropped image save
  saveCandidateImage = (file, candidateId, imageIdentity) => {
    file.storagePath = "eVotingCandidateImages";
    this.commonServices.storeBase64Image(file).then((response) => {
      if (response != null) {
        this.swalServices.Success("Photo Uploaded Successfully");
        this.setState(prevState => {
          const updated = prevState.candidates.map(c => {
            if (c.id === candidateId) {
              return { ...c, imageUrl: response.fileName };
            }
            return c;
          });
          return { candidates: updated };
        });
      } else {
        this.swalServices.Error("Failed to upload photo.");
      }
    });
  };

  // Validate all fields for all candidates
  validateAll = () => {
    let isValid = true;
    const updatedCandidates = this.state.candidates.map(c => {
      const errors = {
        name: c.name.trim() === "" ? "Name is required." : "",
        designation: c.designation.trim() === "" ? "Designation is required." : "",
        companyName: c.companyName.trim() === "" ? "Company name is required." : "",
       //description: c.description.trim() === "" ? "Description is required." : ""
      };
      if (errors.name || errors.designation || errors.companyName ) {
        isValid = false;
      }
      return { ...c, errors };
    });

    this.setState({ candidates: updatedCandidates });
    return isValid;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.validateAll()) {
      const payload = this.state.candidates.map(c => ({
        CandidateId: c.candidateId ?? null,
        CandidateName: c.name ?? "",
        Designation: c.designation ?? "",
        Company: c.companyName ?? "",
        Description: c.description ?? "",
        VideoUrlPath: c.videoUrl ?? "",
        CandidateImage: c.imageUrl ?? "",
        AdminId: this.state.adminUserId ?? null
      }));

      this.eVotingServices.addEditCandidateInformation(payload)
        .then((response) => {
          if (response && response.statusCode === 200 && response.responseItem != null) {
            this.swalServices.Success('Candidates submitted successfully.');
            // reload list from server to reflect any ids assigned
            this.eVotingServices.getAllCandidateList().then((resp) => {
              if (resp && resp.statusCode === 200 && resp.responseItem != null && resp.responseItem.responseContent != null) {
                const list = resp.responseItem.responseContent || resp.responseItem || resp;
                const items = Array.isArray(list) ? list : (Array.isArray(list.responseContent) ? list.responseContent : []);
                if (items && items.length) {
                  const mapped = items.map((x) => ({
                    id: x.candidateId ?? Date.now() + Math.random(),
                    candidateId: x.candidateId ?? null,
                    name: x.candidateName ?? "",
                    designation: x.designation ?? "",
                    companyName: x.company ?? "",
                    videoUrl: x.videoUrlPath ?? "",
                    description: x.description ?? "",
                    imageUrl: x.candidateImage ?? "",
                    errors: { name: "", designation: "", companyName: "", description: "" }
                  }));
                  this.setState({ candidates: mapped });
                }
              }
            }).catch(() => { });
          } else {
            this.swalServices.Error(response ? response.message : 'Failed to submit candidates.');
          }
        })
        .catch((err) => {
          console.error('Submit candidates error', err);
          this.swalServices.Error('Failed to submit candidates.');
        });
    } else {
      this.swalServices.Error("Please fix the errors on the form.");
    }
  };

  render() {
    return (
      <div className="main-body-section">
        <div className="bg-white rounded-sm shadow-md">
          <div className="heading-part px-7 py-4 border-b flex items-center justify-between">
            <h4 className="small-title font-bold theme-color text-2xl">
              Candidates
            </h4>
          </div>
          <div className="px-7 py-4 pt-10">
            <div>
              <div className="mb-6">
                <h5 className="text-xl font-bold mb-6 theme-color">Add Candidate</h5>

                {this.state.candidates.map((candidate, index) => (
                  <div key={candidate.id} className="mb-10 p-6 border border-gray-200 rounded bg-gray-50/50 relative">
                    {/* Header with index and remove 'x' button */}
                    <div className="flex justify-between items-center border-b pb-3 mb-6">
                      <h6 className="text-lg font-bold theme-color">Candidate {index + 1}</h6>
                      <button
                        type="button"
                        onClick={() => this.handleRemoveCandidate(candidate.id)}
                        className="text-gray-400 hover:text-red-600 border border-gray-300 rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold transition duration-150"
                        title="Remove candidate"
                      >
                        &#10005;
                      </button>
                    </div>

                    <div className="grid grid-cols-12 gap-6">
                      {/* Left Column: Form Fields */}
                      <div className="col-span-12 lg:col-span-8">
                        <div className="grid grid-cols-12 gap-6">
                          {/* Name field */}
                          <div className="col-span-12 mb-4">
                            <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                              Name <span className="text-[#C00000]">*</span>
                            </label>
                            <InputText
                              name="name"
                              value={candidate.name}
                              handleChange={(e) => this.handleFieldChange(e, candidate.id)}
                            />
                            <ValidationText error={candidate.errors.name} />
                          </div>

                          {/* Designation field */}
                          <div className="col-span-12 mb-4">
                            <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                              Designation <span className="text-[#C00000]">*</span>
                            </label>
                            <InputText
                              name="designation"
                              value={candidate.designation}
                              handleChange={(e) => this.handleFieldChange(e, candidate.id)}
                            />
                            <ValidationText error={candidate.errors.designation} />
                          </div>

                          {/* Company Name field */}
                          <div className="col-span-12 mb-4">
                            <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                              Company Name <span className="text-[#C00000]">*</span>
                            </label>
                            <InputText
                              name="companyName"
                              value={candidate.companyName}
                              handleChange={(e) => this.handleFieldChange(e, candidate.id)}
                            />
                            <ValidationText error={candidate.errors.companyName} />
                          </div>

                          {/* Video field */}
                          {/* <div className="col-span-12 mb-4">
                            <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                              Video
                            </label>
                            <InputText
                              name="videoUrl"
                              value={candidate.videoUrl}
                              handleChange={(e) => this.handleFieldChange(e, candidate.id)}
                            />
                          </div> */}

                          {/* Description field */}
                          {/* <div className="col-span-12 mb-4"> */}
                            {/* <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                              Description 
                            </label> */}
                            {/* <div className="ck-editor-sec border border-gray-300">
                              <CKClassicEditor
                                key={`description_${candidate.id}`}
                                data={candidate.description}
                                onChange={(event, editor) => this.handleEditorChange(editor.getData(), candidate.id)}
                              />
                            </div> */}
                            {/* <ValidationText error={candidate.errors.description} /> */}
                          {/* </div> */}
                        </div>
                      </div>

                      {/* Right Column: Image Cropper & Upload */}
                      <div className="col-span-12 lg:col-span-4 flex flex-col items-center justify-start border-l border-gray-200 pl-6">
                        <label className="filter-lable block font-medium mb-5 theme-color min-h-30 text-center">
                          Candidate Photo
                        </label>
                        <div className="w-[240px] flex flex-col items-center">
                          <ImageCropperWithUpload
                            keyId={candidate.id}
                            key={`cropper_${candidate.id}`}
                            height={200}
                            width={200}
                            isCheckValidation={true}
                            MaxFileSize={1048576}
                            MaxFileSizeMessage={"1MB"}
                            onSaveImage={this.saveCandidateImage}
                            imageIdentity="eVotingCandidateImages"
                            intitImage={candidate.imageUrl}
                            aspactRatio={200 / 200}
                            uploadBtn={"Upload Photo"}
                            dimensionText={"(Dimension: 200px by 200px Max. Size: 1MB)"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Bottom Buttons */}
              <div className="flex justify-between items-center pt-6 border-t">
                <button
                  type="button"
                  onClick={this.handleAddCandidate}
                  className="btn btn-red-border text-red border border-[#C00000] py-3 px-6 text-lg font-semibold tracking-normal flex items-center gap-2 rounded-none"
                >
                  <span className="text-xl font-bold">+</span> Add Candidate
                </button>

                <button
                  type="button"
                  onClick={this.handleSubmit}
                  className="btn btn-red text-white py-3 px-8 text-lg font-semibold rounded-none tracking-normal"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
